package com.gsb.vyapar.bhagya.presentation.admin.view

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Surface
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.gsb.vyapar.bhagya.domain.*
import com.gsb.vyapar.bhagya.interactor.event.UiEvents
import com.gsb.vyapar.bhagya.interactor.uistate.UiState
import com.gsb.vyapar.bhagya.presentation.admin.util.saveInfoButton
import com.gsb.vyapar.bhagya.presentation.common.button.GVBButton
import com.gsb.vyapar.bhagya.presentation.common.edittext.*
import com.gsb.vyapar.bhagya.presentation.common.image.CommonImage
import com.gsb.vyapar.bhagya.presentation.common.toolbar.Toolbar
import com.gsb.vyapar.bhagya.util.isValidWebsite

@Composable
fun InfoView(uiState: UiState, onTriggerEvent: (UiEvents) -> Unit) {
    var email by remember { mutableStateOf("") }
    var fb by remember { mutableStateOf("") }
    var insta by remember { mutableStateOf("") }
    var x by remember { mutableStateOf("") }
    var share by remember { mutableStateOf("") }
    var about by remember { mutableStateOf("") }
    var support by remember { mutableStateOf("") }
    var terms by remember { mutableStateOf("") }
    var privacy by remember { mutableStateOf("") }
    var upi by remember { mutableStateOf("") }
    var otp by remember { mutableStateOf("") }
    var mobile by remember { mutableStateOf("") }
    var website by remember { mutableStateOf("") }
    var android by remember { mutableStateOf("") }
    var ios by remember { mutableStateOf("") }
    var webapp by remember { mutableStateOf("") }
    var mqttUrl by remember { mutableStateOf("") }
    var mqttPort by remember { mutableStateOf("") }
    var mqttWebPort by remember { mutableStateOf("") }
    var appVersion by remember { mutableStateOf("") }
    var mqttUserName by remember { mutableStateOf("") }
    var mqttPassword by remember { mutableStateOf("") }
    var mqttCertificate by remember { mutableStateOf("") }
    Surface(
        modifier = Modifier.fillMaxSize(),
        color = MaterialTheme.colors.background
    ) {
        Column(
            modifier = Modifier.fillMaxWidth()
        ) {
            Toolbar("Info")
            Column(Modifier.verticalScroll(rememberScrollState()).padding(horizontal = 16.dp)) {
                Spacer(Modifier.height(8.dp))
                EmailEditText(email) { email = it }
                Spacer(Modifier.height(8.dp))
                FbEditText(fb) { fb = it }
                Spacer(Modifier.height(8.dp))
                InstaEditText(insta) { insta = it }
                Spacer(Modifier.height(8.dp))
                XEditText(x) { x = it }
                Spacer(Modifier.height(8.dp))
                DetailEditText("Enter the share details", share) { share = it }
                Spacer(Modifier.height(8.dp))
                DetailEditText("Enter the about details", about) { about = it }
                Spacer(Modifier.height(8.dp))
                DetailEditText("Enter the support details", support) { support = it }
                Spacer(Modifier.height(8.dp))
                WebsiteEditText("Enter the Terms & Conditions Link", terms) { terms = it }
                Spacer(Modifier.height(8.dp))
                WebsiteEditText("Enter the Privacy Link", privacy) { privacy = it }
                Spacer(Modifier.height(8.dp))
                WebsiteEditText("Enter the UPI Link", upi) { upi = it }
                Spacer(Modifier.height(8.dp))
                if (isValidWebsite(upi)) {
                    uiState.getImage(upi)?.let { imageBitmap -> CommonImage(imageBitmap, 50.dp, 50.dp) }
                    Spacer(Modifier.height(8.dp))
                }
                DetailEditText("Enter the OTP message", otp) { otp = it }
                Spacer(Modifier.height(8.dp))
                MobileNumberEditText(mobile) { mobile = it }
                Spacer(Modifier.height(8.dp))
                WebsiteEditText("Enter the Website Link", website) { website = it }
                Spacer(Modifier.height(8.dp))
                AndroidEditText(android) { android = it }
                Spacer(Modifier.height(8.dp))
                IOSEditText(ios) { ios = it }
                Spacer(Modifier.height(8.dp))
                WebsiteEditText("Enter the WebApp Link", webapp) { webapp = it }
                Spacer(Modifier.height(8.dp))
                MqttUrlEditText(mqttUrl) { mqttUrl = it }
                Spacer(Modifier.height(8.dp))
                PortEditText("Enter MQTT port", mqttPort) { mqttPort = it }
                Spacer(Modifier.height(8.dp))
                PortEditText("Enter MQTT Web port", mqttWebPort) { mqttWebPort = it }
                Spacer(Modifier.height(8.dp))
                MqttUserNameEditText(mqttUserName) { mqttUserName = it }
                Spacer(Modifier.height(8.dp))
                MqttPasswordEditText(mqttPassword) { mqttPassword = it }
                Spacer(Modifier.height(8.dp))
                MqttCertificateEditText(mqttCertificate) { mqttCertificate = it }
                Spacer(Modifier.height(8.dp))
                AppVersionEditText(appVersion) { appVersion = it }
                Spacer(Modifier.height(16.dp))
                GVBButton(text = "Save Info") {
                    saveInfoButton(email, fb, insta, x, share, about, support, terms, privacy, upi, otp, mobile, website, android, ios, webapp, mqttUrl, mqttPort, mqttWebPort, mqttUserName, mqttPassword, mqttCertificate, appVersion)
                }
                Spacer(Modifier.height(8.dp))
            }
        }
    }
    LaunchedEffect(Unit) {
        val info = uiState.getInfo()
        email = info.getEmail()
        fb = info.getFb()
        insta = info.getInst()
        x = info.getX()
        share = info.getShare()
        about = info.getAbout()
        support = info.getSupport()
        terms = info.getTerms()
        privacy = info.getPrivacy()
        upi = info.getUpi()
        otp = info.getOtp()
        mobile = info.getMobile()
        website = info.getWebsite()
        android = info.getAndroid()
        ios = info.getIos()
        webapp = info.getWebApp()
        mqttUrl = info.getMqttUrl()
        mqttPort = info.getMqttPort()
        mqttWebPort = info.getMqttWebPort()
        appVersion = info.getAppVersion()
        mqttUserName = info.getMqttUserName()
        mqttPassword = info.getMqttPassword()
        mqttCertificate = info.getMqttCertificate()
    }
}